import { useCallback } from 'react';

import CoursesList, { OrderParams } from '@/components/shared/CoursesList';
import HorizontalList from '@/components/shared/HorizontalList';
import { IPaginationParams } from '@/interfaces/pagination';
import { packageApi } from '@/services/package';

import PackageCard from '../MyCourses/Package/PackageCard';

const MyPackages = () => {
  const [refetch, { data: response, isFetching }] = packageApi.endpoints.getPackages.useLazyQuery();

  const onChoseFilter = useCallback(
    (order: OrderParams) => {
      refetch({ ...order, page: 1, size: 20 });
    },
    [refetch]
  );

  const onReachedEnd = useCallback(
    (params: IPaginationParams) => {
      refetch(params);
    },
    [refetch]
  );

  const onComponentLoad = useCallback(() => {
    refetch({ page: 1, size: 20 });
  }, [refetch]);

  return (
    <CoursesList
      title='Meus Pacotes'
      queryProps={{ data: response, isFetching }}
      onChoseFilter={onChoseFilter}
      onReachPageEnd={onReachedEnd}
      hasFilter={false}
      onComponentLoad={onComponentLoad}
    >
      <HorizontalList
        pagination={{
          totalRows: response?.total_rows,
          totalPages: response?.total_pages,
          pageSize: response?.page.size,
          page: response?.page.page
        }}
        isFetching={isFetching}
      >
        {response?.data.map(packageCourse => (
          <PackageCard {...packageCourse} key={packageCourse.id} packageSize={packageCourse.sorted_courses.length} />
        ))}
      </HorizontalList>
    </CoursesList>
  );
};

export default MyPackages;
